<template>
  <div class="text-center py-5">
    <feather-icon
      icon="AlertTriangleIcon"
      size="48"
      class="text-danger mb-3"
    />
    <h2
      class="mb-2 text-danger"
      aria-label="Accès refusé"
    >
      Accès refusé – Autorisation requise
    </h2>
    <p
      class="lead"
      aria-live="polite"
    >
      Vous n’avez pas les droits nécessaires pour accéder à cette ressource.<br>
      Si vous pensez qu’il s’agit d’une erreur ou si vous avez besoin d’un accès particulier, veuillez contacter l’administrateur de la plateforme logistique.<br>
      <span
        class="d-block mt-2 text-muted"
        style="font-size: 1rem;"
      >
        Code d'erreur : 403 – Accès interdit
      </span>
    </p>
    <router-link
      to="/"
      class="btn btn-primary mt-3"
      aria-label="Retour à l’accueil principal"
    >
      Retour à l’accueil principal
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Forbidden',
}
</script>
